import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-handoff-interstitial',
  standalone: true,
  imports: [MatCardModule, MatButtonModule, MatProgressSpinnerModule, TranslocoModule],
  templateUrl: './handoff-interstitial.component.html',
  styleUrls: ['./handoff-interstitial.component.css'],
})
export class HandoffInterstitialComponent implements OnInit, OnDestroy {
  @Input({ required: true }) redirectUrl = '';
  @Input() delayMs = 1750;

  protected showFallback = false;
  private redirectTimer?: ReturnType<typeof setTimeout>;
  private fallbackTimer?: ReturnType<typeof setTimeout>;

  protected redirect: (url: string) => void = (url) => {
    window.location.assign(url);
  };

  ngOnInit(): void {
    this.redirectTimer = setTimeout(() => {
      this.redirect(this.redirectUrl);
    }, this.delayMs);
    this.fallbackTimer = setTimeout(() => {
      this.showFallback = true;
    }, 5000);
  }

  ngOnDestroy(): void {
    if (this.redirectTimer) {
      clearTimeout(this.redirectTimer);
    }
    if (this.fallbackTimer) {
      clearTimeout(this.fallbackTimer);
    }
  }
}
